import { defineStore } from 'pinia';

import { License, OrganizationFlags } from '../models';

export const useAuthorizationStore = defineStore('authorization', {
    state: () => ({
        organizationFlagsSet: false,
        organizationFlags: 0,
        licensesSet: false,
        licenses: [] as License[]
    }),
    actions: {
        setOrganizationFlags(clientAdmin = false, topLevel = false, publisher = false, hasChildren = false): void {
            this.organizationFlags = 0;
            if (clientAdmin) {
                this.organizationFlags |= OrganizationFlags.ADMIN_CLIENT;
            }
            else {
                this.organizationFlags |= OrganizationFlags.HAS_SHARED;
            }
            if (topLevel) {
                this.organizationFlags |= OrganizationFlags.TOP_LEVEL;
            }
            if (publisher) {
                this.organizationFlags |= OrganizationFlags.PUBLISHER;
            }
            if (hasChildren) {
                this.organizationFlags |= OrganizationFlags.HAS_CHILDREN;
            }
            this.organizationFlagsSet = true;
        },
        cleanOrganizationFlags(): void {
            this.organizationFlags = 0;
            this.organizationFlagsSet = false;
        },
        setLicenses(licenses: License[]): void {
            this.licenses = [...licenses];
            this.licensesSet = true;
        },
        cleanLicenses(): void {
            this.licenses = [];
            this.licensesSet = false;
        }
    },
    getters: {
        isSet: (state): boolean => state.organizationFlagsSet && state.licensesSet
    }
});